import { useLocation, useNavigate } from "react-router-dom";
// @ts-ignore
import CheckSquareIcon from "@assets/svg/CheckSquareIcon";
import UsersIcon from "@assets/svg/UsersIcon";
import { useState } from "react";
import dayjs from "@lib/dayjs";
import MatchedJobs from "./MatchedJobs/MatchedJobs";
import ActivityTracker from "./ActivityTracker/ActivityTracker";
import ChevronLeftIcon from "@assets/svg/ChevronLeftIcon";

const tabs = [
  {
    label: "Matched Jobs",
    // route: "matched-jobs",
  },
  {
    label: "Tracker",
    // route: "matched-jobs",
  },
  {
    label: "Messages",
    // route: "matched-jobs",
  },
];

const NetworkDetailLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const member = location?.state?.member || location?.state;
  const [activeTab, setActiveTab] = useState(0);

  console.log('this is member details',member)

  return (
    <div className="flex flex-col items-center rounded-lg bg-white w-full flex-grow p-5 gap-6">
      <button
        onClick={() => navigate("/network/my-network")}
        className="flex items-center self-start"
      >
        <ChevronLeftIcon className={"w-4 h-4"} fill="#4d4d4d" />
        <label className="text-xs font-medium text-primary cursor-pointer">
          Back to listing
        </label>
      </button>
      <div className="flex items-center border-b w-full pb-2 gap-10 pl-[22.5%]">
        {tabs?.map((tab, tabIndex) => {
          const isActive = tabIndex === activeTab;
          return (
            <button
              key={tab?.label}
              onClick={() => setActiveTab(tabIndex)}
              //   to={`${tab?.route}`}
              //   className={({ isActive }) =>
              //     `font-semibold text-xs ${
              //       isActive
              //         ? "text-primary border-b border-primary"
              //         : "text-light-grey"
              //     }  pb-0.5`
              //   }
              className={`font-semibold text-xs ${
                isActive
                  ? "text-primary border-b border-primary"
                  : "text-light-grey"
              }  pb-0.5`}
            >
              {tab?.label}
            </button>
          );
        })}
      </div>
      <div className="flex w-full flex-1 p-1 min-h-0">
        <div className="flex flex-col w-[20%] border-r gap-7">
          {member?.profilePic ? (
            <img src={member?.profilePic} className="h-28 w-28 rounded-full" />
          ) : (
            <div className="h-28 w-28 font-bold text-light-black flex items-center justify-center bg-gray-100 rounded-full capitalize text-6xl">
              {member?.firstName?.charAt(0) || "T"}
            </div>
          )}
          <span className="font-medium text-primary text-xs">CA-LM026J</span>
          <div className="flex flex-col gap-1">
            <span className="font-medium text-primary capitalize text-xs">
              {member?.firstName || "FirstName"}{" "}
              {member?.lastName || "LastName"}
            </span>
            <span className="font-bold text-xs">
              {member?.jobTitle || "Job Title"}
            </span>
          </div>
          <span className="text-primary italic text-xs">
            Last seen 2 days ago
          </span>
          <div className="flex flex-col gap-1">
            <span className="font-bold text-xs">Status</span>
            <span className="text-primary capitalize text-xs">
              {member?.isActive ? "Available" : "Unavailable"}
            </span>
          </div>
          <div className="flex flex-col gap-1">
            <span className="font-bold text-xs">Joined my network</span>
            <span className="text-primary capitalize text-xs">
              {dayjs().format("DD MMM YYYY")}
            </span>
          </div>
        </div>
        {/* Outlet container */}
        <div className="flex flex-col w-[80%] min-h-0">
          {activeTab == 0 ? <MatchedJobs /> : <ActivityTracker />}
          {/* <Outlet context={outletContext} /> */}
        </div>
      </div>
    </div>
  );
};

export default NetworkDetailLayout;
